// <div data-controller="regions--select">
//
// </div>
import { Controller } from "stimulus";
import api from "utils/api";
import SlimSelect from "slim-select";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [ "select" ];
  static classes = [ "" ]
  static values = {
    options: Object
  };

  initialize() {
    this.searchableTimeout = null;
    this.searchKeyword = null;
    this.slim;
  }

  fetchRegions = (search, callback) => {
    if (this.searchableTimeout != null) {
      clearTimeout(this.searchableTimeout);
    }

    if (this.searchKeyword === search.trim() || search.trim() === "") {
      callback()
      return;
    }

    this.searchableTimeout = setTimeout(() => {
      this.searchableTimeout = null;
      this.searchKeyword = search.trim();
      api.get(`/admin/regions.json?q%5Bname_cont%5D=${search}&q%5Bid_eq%5D=${search}&q%5Bm%5D=or`).then((res) => {
        let data = []
        res.data.regions.forEach((region) => {
          data.push({ value: region.id, text: `${region.name} (${region.id}/ depth: ${region.depth})` })
        })
        callback(data);
      })
    }, 500)
  }

  connect() {
    const options = {
      select: this.selectTarget,
      closeOnSelect: false,
      data: this.optionsValue.data,
      ajax: this.fetchRegions
    }

    this.slim = new SlimSelect(options);
    this.slim.set(this.optionsValue.data.map((option) => option.value));
  }

  disconnect() {
    this.slim.destroy();
  }
}